module.exports = __webpack_public_path__ + "static/Laptop2_mobilePR-80bc42fec0db12aae84a27d236c2f9d6.mp4";